import name from './name'

const selectSliceData = state => state[name]

const selectReportList = (state, currentType) => selectSliceData(state).reportKeyList[currentType]

export {
  selectReportList,
}
